import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/admin/verify-token`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const GET_USER_PERMISSIONS = `${API_URL}/user-permissions/`
export const FORGET_PASSWORD_URL = `${API_URL}/forget-password`
export const RESET_PASSWORD_URL = `${API_URL}/reset-password`
// all permissions of logged in user
export const get_user_permissions = async () => {
  // Get auth token from localStorage
  const storedData = localStorage.getItem('kt-auth-react-v');
  const parsedData = storedData ? JSON.parse(storedData) : null;
  const api_token = parsedData?.api_token || parsedData?.access_token || null;
  
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: api_token ? `Bearer ${api_token}` : undefined,
  };
  
  let response = await axios.get(`${API_URL}/user-permissions`, { headers });
  return response.data;
}
// Server should return AuthModel
export async function login(email: string, password: string) {
  const response = await axios.post(LOGIN_URL, {
    email,
    password,
  })
  return response?.data
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(FORGET_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
export async function resetPassword(token: string, email: string, password: string, password_confirmation: string,) {
  const response = await axios.post<{result: boolean}>(RESET_PASSWORD_URL, {
    email,
    password,
    password_confirmation,
    token,
  })
  return response?.data
}
// Sign Out
export async function signout(api_token: string) {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${api_token}`,
  };
  const response = await axios.post(`${API_URL}/logout`, {api_token: api_token}, { headers });
  return response?.data;
}